import React from 'react';

type SortIconsProps = {
  sizePx?: number;
  direction?: 'asc' | 'desc';
};

function SortIcon({ sizePx, direction }: SortIconsProps) {
  let upArrowColor = '#DADDE3';
  let downArrowColor = '#DADDE3';

  if (direction === 'asc') {
    upArrowColor = '#9499a3';
  }
  if (direction === 'desc') {
    downArrowColor = '#9499a3';
  }

  return (
    <svg
      role="img"
      width={sizePx}
      height={sizePx}
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="0"
      viewBox="0 0 24 24"
    >
      <path d="M7 14L12 20L17 14H7Z" fill={upArrowColor} />
      <path d="M17 10L12 4L7 10L17 10Z" fill={downArrowColor} />
    </svg>
  );
}

export { SortIcon };
